import React, { useEffect } from "react";
import { ReactComponent as MainIcon } from "../../assets/MainPage/componentIconSvg.svg";
import { ReactComponent as MainIconDark } from "../../assets/MainPage/componentIconSvgDark.svg";

import { Outlet } from "react-router-dom";
import OgImage from "../../assets/landingPages/homePage/Hero.png";
import { useStateContext } from "../../contexts/ThemeContext";
import useLocales from "../../hooks/useLocales";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";

// this page will render Dashboard/Component
// After login its first page will be rendered

const MainPage = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { setActiveMainPageNav } = useStateContext();

  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Components | Bil.Bio</title>
        <meta property="og:title" content="Components | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <div className="bg-light_bg_v4 dark:bg-dark-primary h-[100vh] sm:px-[76px] md:px-10 lg:px-12 xl:px-[100px] md:py-10 overflow-y-auto">
        <div className="hidden mb-11 md:flex items-center gap-[10px]">
          <div
            style={{
              boxShadow: darkMode
                ? ""
                : "0px 0px 10px rgba(217, 217, 217, 0.1), -5px 6px 10px rgba(170, 170, 170, 0.3)",
            }}
            className="hidden md:flex justify-center items-center p-[9px] bg-white dark:bg-dark-secondary rounded-lg  "
          >
            {darkMode ? <MainIconDark /> : <MainIcon />}
          </div>
          <h6 className=" text-custom_h6 text-heading_color dark:text-color_v1_dark">
            {translate("components")}
          </h6>
        </div>
        <Outlet />
      </div>
    </>
  );
};

export default MainPage;
